import { render, staticRenderFns } from "./Academic_rank.vue?vue&type=template&id=61810adf&scoped=true"
import script from "./Academic_rank.vue?vue&type=script&lang=js"
export * from "./Academic_rank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61810adf",
  null
  
)

export default component.exports